import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        // Only handle file inputs that aren't already handled by other JavaScript
        if (this.element.type === 'file' && !this.element.dataset.skipStimulus) {
            this.element.addEventListener('change', this.handleFileUpload.bind(this))
        }
    }

    async handleFileUpload(event) {
        // Prevent event from bubbling to other handlers
        event.stopPropagation()
        event.stopImmediatePropagation()

        const file = event.target.files[0]
        if (!file) return

        const responseId = this.element.dataset.responseId
        const fieldId = this.element.dataset.fieldId
        const customFieldValueId = this.element.dataset.customFieldValueId

        if (!responseId || !fieldId) {
            return
        }

        // Visual feedback - add classes to field and parent elements
        const fieldGroup = this.element.closest('.response-field-group')
        const responseItem = this.element.closest('.response-item')

        this.element.classList.remove('saved', 'error')
        this.element.classList.add('saving')

        if (fieldGroup) {
            fieldGroup.classList.remove('field-saved', 'field-error')
            fieldGroup.classList.add('field-saving')
        }

        // Create FormData for file upload
        const formData = new FormData()
        formData.append('file', file)
        formData.append('field_id', fieldId)

        try {
            // Upload the file
            const response = await fetch(`/struct_responses/${responseId}/upload_file`, {
                method: 'POST',
                headers: {
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                    'Accept': 'application/json'
                },
                body: formData
            })

            const data = await response.json()

            if (response.ok && data.success) {
                // Update visual feedback for success
                this.element.classList.remove('saving', 'error')
                this.element.classList.add('saved')

                if (fieldGroup) {
                    fieldGroup.classList.remove('field-saving', 'field-error')
                    fieldGroup.classList.add('field-saved')
                }

                // Update the file display
                this.updateFileDisplay(data.file_url || data.url, data.file_name || file.name)

                // Show notification
                this.showFieldNotification('File uploaded', 'success')

                // Remove success state after 2 seconds
                setTimeout(() => {
                    this.element.classList.remove('saved')
                    if (fieldGroup) {
                        fieldGroup.classList.remove('field-saved')
                    }
                }, 2000)
            } else {
                throw new Error(data.error || "Upload failed")
            }
        } catch (error) {
            // Update visual feedback for error
            this.element.classList.remove('saving', 'saved')
            this.element.classList.add('error')

            if (fieldGroup) {
                fieldGroup.classList.remove('field-saving', 'field-saved')
                fieldGroup.classList.add('field-error')
            }

            // Show error notification
            this.showFieldNotification(error.message || 'Error uploading file', 'error')
        }
    }

    updateFileDisplay(fileUrl, fileName) {
        // Find or create the file display element
        let fileDisplay = this.element.parentElement.querySelector('small.form-text.text-muted')

        if (!fileDisplay) {
            fileDisplay = document.createElement('small')
            fileDisplay.className = 'form-text text-muted'
            this.element.parentElement.appendChild(fileDisplay)
        }

        // Update the display with a link to the uploaded file
        fileDisplay.innerHTML = `Current file: <a href="${fileUrl}" target="_blank" class="text-primary">${fileName}</a>`
    }

    showFieldNotification(message, type = 'success') {
        const notification = document.createElement('div')
        notification.className = 'field-notification'
        notification.classList.add(type === 'error' ? 'notification-error' : 'notification-success')
        notification.textContent = message

        const fieldGroup = this.element.closest('.response-field-group') || this.element.parentElement
        const originalPosition = fieldGroup.style.position
        fieldGroup.style.position = 'relative'
        fieldGroup.appendChild(notification)

        setTimeout(() => {
            notification.style.opacity = '0'
            setTimeout(() => {
                notification.remove()
                fieldGroup.style.position = originalPosition
            }, 300)
        }, 2000)
    }

    disconnect() {
        // Clean up event listeners if needed
        if (this.element.type === 'file' && !this.element.dataset.skipStimulus) {
            this.element.removeEventListener('change', this.handleFileUpload.bind(this))
        }
    }
} 